import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { css, cx } from '@flipster/styled-system/css';
import { circle, flex, hstack, stack } from '@flipster/styled-system/patterns';
import { numberFormatter } from '@flipster/utils/num';

import { TopNBidderItem, sparkAuctionBunja } from '../_bunja';

const TopNBids = () => {
  const { topNBiddersAtom } = useBunja(sparkAuctionBunja);
  const topNBidders = useAtomValue(topNBiddersAtom);
  return (
    <div>
      <h2 className={css({ textStyle: 'Title/S', mb: 16 })}>
        <FormattedMessage id='Autogen_common.r251126.s_Top_10_bids' />
      </h2>
      <div>
        <div
          className={flex({
            py: 8,
            justifyContent: 'space-between',
            textStyle: 'Text/XS/Regular',
            color: 'content.default.level-2',
            borderBottom: '1px solid {colors.border.default.level-1}',
          })}
        >
          <div>
            <FormattedMessage id='Autogen_common.r251126.s_Username' />
          </div>
          <div>
            <FormattedMessage id='Autogen_common.r251126.s_Sparks' />
          </div>
        </div>
        <ol className={stack()}>
          {topNBidders.map((bidder, index) => (
            <ListItem key={index} number={index + 1} bidder={bidder} />
          ))}
        </ol>
      </div>
    </div>
  );
};

export default TopNBids;

interface ListItemProps {
  number: number;
  bidder?: TopNBidderItem;
}
const ListItem = ({ number, bidder }: ListItemProps) => {
  return (
    <li className={hstack({ py: 16, gap: 16, borderBottom: '1px solid {colors.border.default.level-1}' })}>
      <span
        className={cx(
          circle({ w: 24, h: 24, textStyle: 'Text/S/Strong' }),
          bidder?.isMe
            ? css({ bg: 'background.accent.secondary', color: 'inverse.black' })
            : css({ bg: 'background.default.level-3' }),
        )}
      >
        {number}
      </span>
      <span className={css({ textStyle: 'Text/M/Strong' })}>{bidder ? bidder.nickname : '-'}</span>
      <span className={css({ flexGrow: 1, textAlign: 'right', textStyle: 'Text/M/Regular' })}>
        {bidder ? numberFormatter(bidder.amount) : '-'}
      </span>
    </li>
  );
};
